import { useRef, ChangeEvent } from "react";
import CustomImage from "./CustomImage";
import CustomText from "../atomic/CustomText";
import CustomImageUploaderProps from "../../services/models/customImageUploader.model";
import Button from "../organism/Button";
import toastMessages from "../../services/utils/helpers/toastMessage";
import { normalizeUploadFile } from "../../services/utils/helpers/fileNameNormalizer";

export default function ImageUploader({
  value,
  onChange,
  name,
  id,
  disabled,
}: CustomImageUploaderProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  async function handleDrop(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    const file = event.dataTransfer.files[0];
    const normalizedFile = file ? normalizeUploadFile(file) : null;
    if (normalizedFile && validateFile(normalizedFile))
      if (onChange) {
        onChange({
          target: {
            name: name ? name : "logo",
            value: normalizedFile,
          },
        });
      }
  }

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // event.currentTarget.classList.add('border-2', 'border-dashed', 'border-blue-500');
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // event.currentTarget.classList.remove('border-2', 'border-dashed', 'border-blue-500');
  };
  const validateFile = (file: any): boolean => {
    let sizeInMB = null;
    sizeInMB = file.size / 1024 / 1024;

    function getExt(filename: string): any {
      const ext = filename.split(".").pop();
      if (ext === filename) return "";
      return ext;
    }
    if (![
      "image/jpeg",
      "image/jpg",
      "image/png",
      "png",
      "jpg",
      "jpeg",
    ].includes(getExt(file.name)?.toLowerCase())) {
      toastMessages.error(`Invalid file format`);
      return false;
    }
    if (sizeInMB > 55) {
      alert("File size limit is being exceeded");
      return false;
    }
    return true;
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const normalizedFile = normalizeUploadFile(file);
      if (validateFile(normalizedFile))
        onChange({
          target: {
            name: name ? name : "logo",
            value: normalizedFile,
          },
        });
    }
  };

  return (
    <div className={`${disabled ? "cursor-not-allowed" : ""}`}>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
        className={`${disabled && "cursor-not-allowed"}`}
      >
        <div
          onDragOver={handleDragOver}
          onDragEnter={(e) => e.preventDefault()}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className={`${disabled ? "cursor-not-allowed" : "cursor-pointer"
            } relative`}
        >
          <CustomImage
            ImageUpload
            disabled={disabled}
            src={
              value instanceof File
                ? URL.createObjectURL(value)
                : !!value
                  ? value
                  : ""
            }
            alt="Upload Image"
          />
          {!!value && (
            <button
              type="button"
              className={`bg-requiredRed ${disabled ? 'cursor-not-allowed' : ''} border-roundedInputBorder shadow-md border rounded-full h-5 w-5 absolute top-0 right-8`}
              onClick={(e) => {
                e.stopPropagation();
                onChange?.({ target: { name: name, value: "" } });
              }}
            // disabled={disabled}
            >
              <CustomText
                text="X"
                fontWeight="font-semibold"
                fontSize="text-xs text-white"
              />
            </button>
          )}
        </div>
        <CustomText
          text="Upload Image"
          fontWeight="font-semibold"
          className="mt-2 text-primary uppercase tracking-widest leading-5"
        />
        <input
          ref={inputRef}
          name={!!name ? name : "logo"}
          id={!!id ? id : "logo"}
          type="file"
          accept="image/*"
          onChange={handleInputChange}
          hidden
        />
      </button>
    </div>
  );
}
